var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAv8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_43598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#EAEAEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_43598)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_43598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 107.023C82.2711 107.023 106 83.2945 106 54.0234C106 24.7523 82.2711 1.02344 53 1.02344C23.7289 1.02344 0 24.7523 0 54.0234C0 83.2945 23.7289 107.023 53 107.023Z",
    fill: "#FFC1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8691 89.6517L48.0464 89.6367C46.6906 89.8758 45.4623 90.5849 44.5773 91.6395C43.6922 92.6941 43.207 94.0268 43.2068 95.4036V108.702H63.5995V95.4036C63.5997 94.0452 63.1281 92.7289 62.2652 91.6798C61.4024 90.6306 60.202 89.9138 58.8691 89.6517Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9714 99.333H43.2068V118.884H47.9714V99.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8416 118.883H63.6062V99.3317H58.8416V118.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6772 70.9738C86.1944 59.4566 86.1944 40.7836 74.6772 29.2664C63.1601 17.7493 44.4871 17.7493 32.9699 29.2664C21.4527 40.7836 21.4527 59.4566 32.9699 70.9738C44.4871 82.491 63.1601 82.491 74.6772 70.9738Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6267 76.3156C83.0107 65.9316 83.0107 49.0958 72.6267 38.7117C62.2427 28.3277 45.4069 28.3277 35.0229 38.7117C24.6389 49.0958 24.6389 65.9316 35.0229 76.3156C45.4069 86.6996 62.2427 86.6996 72.6267 76.3156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0293 89.6607V83.8339C48.029 83.1209 48.1692 82.4148 48.4419 81.7559C48.7146 81.097 49.1144 80.4984 49.6185 79.994C50.1226 79.4897 50.7211 79.0897 51.3799 78.8167C52.0387 78.5438 52.7447 78.4033 53.4578 78.4033C54.171 78.403 54.8773 78.5433 55.5363 78.8161C56.1953 79.0889 56.7941 79.4889 57.2984 79.9933C57.8028 80.4976 58.2028 81.0964 58.4756 81.7554C58.7484 82.4144 58.8887 83.1207 58.8884 83.8339V89.6607L53.3079 92.9714L48.0293 89.6607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1815 64.4816C42.8597 64.4816 44.2202 63.1212 44.2202 61.443C44.2202 59.7648 42.8597 58.4043 41.1815 58.4043C39.5033 58.4043 38.1428 59.7648 38.1428 61.443C38.1428 63.1212 39.5033 64.4816 41.1815 64.4816Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2232 64.4816C66.9014 64.4816 68.2619 63.1212 68.2619 61.443C68.2619 59.7648 66.9014 58.4043 65.2232 58.4043C63.545 58.4043 62.1846 59.7648 62.1846 61.443C62.1846 63.1212 63.545 64.4816 65.2232 64.4816Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7532 65.2979C48.6097 71.3088 50.6826 75.5595 53.1067 75.5595C55.5308 75.5595 57.6165 71.3088 58.4602 65.2979H47.7532Z",
    fill: "#FFC1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8777 25.4551C62.8622 24.3214 67.6052 17.7402 66.4714 10.7557C65.3377 3.77125 58.7565 -0.971725 51.772 0.162019C44.7875 1.29576 40.0446 7.8769 41.1783 14.8614C42.3121 21.8459 48.8932 26.5889 55.8777 25.4551Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5158 54.1321C68.7321 54.1321 79.4461 48.2415 79.4461 40.9752C79.4461 33.7089 68.7321 27.8184 55.5158 27.8184C42.2994 27.8184 31.5854 33.7089 31.5854 40.9752C31.5854 48.2415 42.2994 54.1321 55.5158 54.1321Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8961 37.2109H57.4497C52.777 37.2109 48.989 40.9989 48.989 45.6717C48.989 50.3444 52.777 54.1324 57.4497 54.1324H80.8961C85.5688 54.1324 89.3568 50.3444 89.3568 45.6717C89.3568 40.9989 85.5688 37.2109 80.8961 37.2109Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7206 70.6861C43.572 70.6861 45.8835 69.6803 45.8835 68.4397C45.8835 67.1991 43.572 66.1934 40.7206 66.1934C37.8691 66.1934 35.5576 67.1991 35.5576 68.4397C35.5576 69.6803 37.8691 70.6861 40.7206 70.6861Z",
    fill: "#FFC1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5975 70.6861C68.4489 70.6861 70.7605 69.6803 70.7605 68.4397C70.7605 67.1991 68.4489 66.1934 65.5975 66.1934C62.7461 66.1934 60.4346 67.1991 60.4346 68.4397C60.4346 69.6803 62.7461 70.6861 65.5975 70.6861Z",
    fill: "#FFC1C1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_43598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv8);
export default __webpack_public_path__ + "static/media/Av8.4421b80e68d96294887b73715ce3e7cb.svg";
export { ForwardRef as ReactComponent };